import React from 'react';
import { NavLink } from 'react-router-dom';

import { printMissingConfigError, SiteConfigManager } from '@atlas/core';
import { Label } from '@atlas/ui';

import { navigationTypes } from './constants';

const Header = () => {
  const pages = SiteConfigManager.getConfig('config.pages', []);
  const navigationList = pages.filter(({ isActive, type }) => isActive && navigationTypes[type]);

  if (pages.length === 0) {
    printMissingConfigError('config.pages');
  }

  return (
    <header className="header">
      <div className="tabs-list">
        {navigationList.map(
          ({ path, type }) =>
            type !== 'results' && (
              <NavLink key={type} to={path} className="tab-list-item">
                <Label message={navigationTypes[type]} />
              </NavLink>
            ),
        )}
      </div>
    </header>
  );
};

export default Header;
